import { type Plugin } from "@nuxt/types";

import LinkService from "@/utils/services/LinkService";

declare module "vue/types/vue" {
  interface Vue {
    $linkService: LinkService;
  }
}

declare module "@nuxt/types" {
  interface Context {
    $linkService: LinkService;
  }
}

declare module "vuex/types/index" {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface Store<S> {
    $linkService: LinkService;
  }
}

/**
 * @TODO Convert this to a composable only used in components
 */
const plugin: Plugin = (context, inject) => {
  const linkService = new LinkService(context);
  context.app.router?.onReady(() => {
    linkService.initialPage = context.route.name ?? "direct";
  });
  inject("linkService", linkService);
  context.$linkService = linkService;
};

export default plugin;
